import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Sun, Moon } from 'lucide-react';

const Navbar = ({ theme, toggleTheme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);

  // Helper to close menu when clicking a link
  const closeMenu = () => setIsOpen(false);

  // Replace with actual logo import or URL
  const logoUrl = "/ValuVantLogo.png"; 

  return (
    <nav className="navbar">
      <div className="container nav-container">
        <Link to="/" className="logo" onClick={closeMenu}>
          {/* Assuming logo file is in public folder or imported */}
          <img src={logoUrl} alt="ValuVant" className="logo-img" />
          <span style={{ color: 'var(--primary-gold)' }}>Valu<span style={{ color: 'var(--primary-red)' }}>Vant</span></span>
        </Link>

        {/* Desktop & Mobile Actions Wrapper */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          
          <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
            <li><Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={closeMenu}>Home</Link></li>
            <li><Link to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`} onClick={closeMenu}>About Us</Link></li>
            <li><Link to="/services" className={`nav-link ${location.pathname === '/services' ? 'active' : ''}`} onClick={closeMenu}>Services</Link></li>
            <li><Link to="/portfolio" className={`nav-link ${location.pathname === '/portfolio' ? 'active' : ''}`} onClick={closeMenu}>Capabilities</Link></li>
            <li><Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`} onClick={closeMenu}>Contact</Link></li>
          </ul>

          {/* Theme Toggle Button */}
          <button onClick={toggleTheme} className="theme-toggle" aria-label="Toggle Dark Mode">
            {theme === 'light' ? <Moon size={24} /> : <Sun size={24} />}
          </button>

          <div className="mobile-menu-icon" onClick={toggleMenu}>
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </div>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;